<!-- <template>
    <div class="max-w-3xl mx-auto mt-10 bg-white p-6 rounded-2xl shadow-lg">
        <div class="mb-6">
            <div class="flex justify-between mb-4 text-sm font-semibold text-gray-600">
                <span
                    v-for="(step, index) in steps"
                    :key="index"
                    :class="{ 'text-green-600': currentStep > index, 'text-blue-600': currentStep === index }"
                >
                    {{ step.label }}
                </span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-2.5">
                <div
                    class="bg-blue-500 h-2.5 rounded-full transition-all duration-500 ease-in-out"
                    :style="{ width: ((currentStep + 1) / steps.length) * 100 + '%' }"
                ></div>
            </div>
        </div> -->
<!-- <transition
            name="fade"
            mode="out-in"
        >
            <component
                :is="steps[currentStep].component"
                :key="currentStep"
                :form="form"
                :errors="errors"
                @updateForm="updateForm"
            />
        </transition>

        <div class="mt-6 flex justify-between">
            <t-button
                v-if="currentStep > 0"
                variant="secondary"
                @click="prevStep"
                >Back</t-button
            >
            <t-button
                v-if="currentStep < steps.length - 1"
                @click="nextStep"
                >Next</t-button
            >
            <t-button
                v-if="currentStep === steps.length - 1"
                variant="success"
                @click="submitForm"
                >Submit</t-button
            >
        </div>
    </div>
</template> -->
<template>
    <div class="max-w-3xl mx-auto mt-6 bg-white p-6 rounded-2xl shadow-lg">
        <div class="flex justify-between items-center mb-6">
            <div
                v-for="(step, index) in steps"
                :key="index"
                class="text-center flex-1"
            >
                <div :class="stepClass(index)">{{ index + 1 }}</div>
                <div
                    class="text-sm mt-1"
                    :class="labelClass(index)"
                >
                    {{ step.label }}
                </div>
            </div>
        </div>

        <transition
            name="fade"
            mode="out-in"
        >
            <component
                :is="steps[currentStep].component"
                :key="currentStep"
                :form="form"
                :errors="internalErrors"
                @updateForm="updateForm"
            />
        </transition>

        <div class="mt-6 flex justify-between items-center">
            <button
                v-if="currentStep > 0"
                @click="prevStep"
                class="btn"
            >
                ← Back
            </button>
            <button
                v-if="currentStep < steps.length - 1"
                @click="nextStep"
                class="btn-primary ml-auto"
            >
                Next →
            </button>
            <button
                v-if="currentStep === steps.length - 1"
                @click="submitForm"
                class="btn-success ml-auto"
            >
                Submit
            </button>
        </div>
    </div>
</template>

<script>
    import Kyc from '../../Models/Kyc';
    import StepOne from './StepOne.vue';
    import StepTwo from './StepTwo.vue';
    import StepThree from './StepThree.vue';
    import StepFour from './StepFour.vue';
    import StepFive from './StepFive.vue';

    export default {
        props: ['kyc'],
        components: { StepOne, StepTwo, StepThree, StepFour, StepFive },
        data() {
            return {
                currentStep: 0,
                draftKey: 'kyc_draft_data',
                form: new Kyc(),
                internalErrors: {},
                processing: false,
                steps: [
                    { label: 'Personal Info', component: 'StepOne' },
                    { label: 'Company Details', component: 'StepTwo' },
                    { label: 'Bank Details', component: 'StepThree' },
                    { label: 'Documents Upload', component: 'StepFour' },
                    { label: 'Confirmation', component: 'StepFive' },
                ],
            };
        },

        mounted() {
            const draft = localStorage.getItem(this.draftKey);
            if (draft) {
                try {
                    this.form = JSON.parse(draft);
                    this.$toast?.info?.('Draft loaded from previous session.');
                } catch (e) {
                    console.warn('Failed to load draft');
                }
            }

            if (this.kyc) {
                Object.assign(this.form, {
                    logoPreview: this.kyc.logo,
                    personName: this.kyc.person_name,
                    email: this.kyc.email,
                    phone: this.kyc.phone,
                    dob: this.kyc.dob,
                    gender: this.kyc.gender,

                    companyName: this.kyc.company_name,
                    companyRegistrationNumber: this.kyc.company_registration_number,
                    businessAddress: this.kyc.business_address,

                    bankersName: this.kyc.bankers_name,
                    bankersAddress: this.kyc.bankers_address,
                    businessReferencesName: this.kyc.business_references_name,
                    businessReferencesAddress: this.kyc.business_references_address,

                    idDocumentPreview: this.kyc.id_document,
                    registrationCertificatePreview: this.kyc.registration_certificate,
                    acceptVat: this.kyc.accept_vat,
                });
            }
        },

        methods: {
            stepClass(index) {
                return (
                    `w-10 h-10 mx-auto rounded-full flex items-center justify-center border-2 ` +
                    (this.currentStep === index
                        ? 'bg-green-600 text-white'
                        : this.currentStep > index
                        ? 'bg-blue-500 text-white'
                        : 'text-gray-400 border-gray-300')
                );
            },
            labelClass(index) {
                return this.currentStep === index ? 'text-green-600 font-semibold' : 'text-gray-400';
            },
            nextStep() {
                if (this.validateStep()) {
                    this.currentStep++;
                    this.saveDraft();
                }
            },
            prevStep() {
                if (this.currentStep > 0) {
                    this.currentStep--;
                }
            },
            saveDraft() {
                localStorage.setItem(this.draftKey, JSON.stringify(this.form));
            },
            deleteDraft() {
                localStorage.removeItem(this.draftKey);
            },
            updateForm(payload) {
                Object.assign(this.form, payload);
            },
            validateStep() {
                this.internalErrors = {};
                switch (this.currentStep) {
                    case 0:
                        if (!this.form.personName) this.internalErrors.person_name = 'Person Name is required';
                        if (!this.form.email) this.internalErrors.email = 'Email is required';
                        if (!this.form.phone) this.internalErrors.phone = 'Phone is required';
                        if (!this.form.dob) this.internalErrors.dob = 'DOB is required';
                        if (!this.form.gender) this.internalErrors.gender = 'Gender is required';
                        if (!this.form.role) this.internalErrors.role = 'Role is required';
                        break;
                    case 1:
                        if (!this.form.companyName)
                            this.internalErrors.business_references_name = 'Company Name is required';
                        if (!this.form.companyRegistrationNumber)
                            this.internalErrors.company_registration_number = 'Company Registration Number is required';
                        if (!this.form.businessAddress)
                            this.internalErrors.business_address = 'Company Address is required';
                        if (!this.form.businessReferencesName)
                            this.internalErrors.business_references_name = 'Company Reference Name is required';
                        if (!this.form.businessReferencesAddress)
                            this.internalErrors.business_references_address = 'Company Reference Address is required';
                        break;
                    case 2:
                        if (!this.form.bankersName) this.internalErrors.bankers_name = 'Banker Name is required';
                        if (!this.form.bankersAddress)
                            this.internalErrors.bankers_address = 'Bankers Address is required';

                        break;
                    case 4:
                        // if (!this.form.agree) this.internalErrors.agree = 'You must agree to terms';
                        break;
                }
                return Object.keys(this.internalErrors).length === 0;
            },

            // save(payload) {
            //     this.$inertia.post(route('kyc.store'), payload, {
            //         onFinish: () => {
            //             this.processing = false;
            //         },
            //     });
            // },

            async submitForm() {
                if (this.validateStep()) {
                    this.$emit('processing', true); // 🔹 Inform parent: start
                    const payload = this.buildPayload();

                    console.log(payload);
                    await this.$inertia.post(route('kyc.store'), payload, {
                        onSuccess: () => {
                            this.$emit('completed', this.form);
                        },
                        onFinish: () => {
                            this.$emit('processing', false); // 🔹 Inform parent: end
                        },
                    });
                }

                setTimeout(() => {
                    this.deleteDraft();
                }, 1000);
            },

            buildPayload() {
                const formData = new FormData();
                if (this.form.logo) {
                    formData.append('logo', this.form.logo);
                }
                if (this.form.personName) {
                    formData.append('person_name', this.form.personName);
                }
                if (this.form.email) {
                    formData.append('email', this.form.email);
                }
                if (this.form.phone) {
                    formData.append('phone', this.form.phone);
                }
                if (this.form.dob) {
                    formData.append('dob', this.form.dob);
                }
                if (this.form.gender) {
                    formData.append('gender', this.form.gender);
                }
                if (this.form.role) {
                    formData.append('role', this.form.role);
                }
                if (this.form.companyName) {
                    formData.append('company_name', this.form.companyName);
                }
                if (this.form.companyRegistrationNumber) {
                    formData.append('company_registration_number', this.form.companyRegistrationNumber);
                }
                if (this.form.businessAddress) {
                    formData.append('business_address', this.form.businessAddress);
                }
                if (this.form.bankersName) {
                    formData.append('bankers_name', this.form.bankersName);
                }
                if (this.form.bankersAddress) {
                    formData.append('bankers_address', this.form.bankersAddress);
                }
                if (this.form.businessReferencesName) {
                    formData.append('business_references_name', this.form.businessReferencesName);
                }
                if (this.form.businessReferencesAddress) {
                    formData.append('business_references_address', this.form.businessReferencesAddress);
                }
                if (this.isWholesaler) {
                    formData.append('accept_vat', this.form.acceptVat ? 1 : 0);
                }
                if (this.form.idDocument) {
                    formData.append('id_document', this.form.idDocument);
                }
                if (this.form.registrationCertificate) {
                    formData.append('registration_certificate', this.form.registrationCertificate);
                }
                if (this.form.vatRegistrationCertificate) {
                    formData.append('vat_registration_certificate', this.form.vatRegistrationCertificate);
                }
                if (this.form.images) {
                    for (let i = 0; i < this.form.images.length; i++) {
                        const file = this.form.images[i];
                        formData.append(`images[${i}]`, file);
                    }
                }
                if (this.kyc && this.kyc.id) {
                    // to send put request the param name should have been _method for laravel
                    // but this param is being sent to the store method to let it know how to handle the data
                    // we create new one if this param doesn't exist and update existing data otherwise in the same controller method
                    formData.append('method', 'PUT');
                }
                console.log(this.key);
                return formData;
            },
        },
    };
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
